import React from 'react';
import './Button.css';

const TYPES = ['primary', 'outline', 'primary-float'];
const COLOURS = ['white', 'dark-blue', 'light-blue', 'grey', 'light-grey', 'red', 'off-white', 'yellow'];
const SIZES = ['medium', 'large', 'small', 'wide'];
const BUTTONTYPES = ['submit', 'button'];

const Button = ({
	buttonType,
	buttonColour,
	buttonSize,
	children,
	onClick,
	inputType,
	isDissabled,
}) => {

	const checkButtonStyle = TYPES.includes(buttonType) ? buttonType : TYPES[0];
	const checkButtonColor = COLOURS.includes(buttonColour) ? buttonColour : COLOURS[0];
	const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];
	const checkButtonType = BUTTONTYPES.includes(inputType) ? inputType : BUTTONTYPES[0];

	return (
		<button type={`${checkButtonType}`}
			className={`${checkButtonStyle} ${checkButtonColor} ${checkButtonSize} ${isDissabled ? 'dissable' : ''}`}
			onClick={onClick}
			disabled={isDissabled ? true : false}
		>{children}</button>
	);
};

export default Button;
